<template>
  <LazyContainer
    v-editable="blok"
    :no-padding="blok.noPadding"
    :padding-top="blok.paddingTop"
    :full-width="blok.fullWidth"
    :full-height="blok.fullHeight">
    <template v-if="blok.fullWidth">
      <StoryblokComponent v-for="blokBody in blok.blocks" :key="blokBody._uid" :blok="blokBody" />
    </template>
    <template v-else>
      <div
        v-for="blokBody in blok.blocks"
        :key="blokBody._uid"
        :class="[$style['column'], WIDE.includes(blokBody.component) && $style['column--wide']]">
        <StoryblokComponent :blok="blokBody" />
      </div>
    </template>
  </LazyContainer>
</template>
<script setup>
defineProps({ blok: Object })

// Text sits in one centred reading column; video, large photos, maps and the sponsor logos may use a wider band
const WIDE = ['SbMovie', 'SbImage', 'SbGoogleMap', 'SbIFrame', 'SbSponsorScroller', 'SbNewsOverview']
</script>
<style module>
.column {
  max-width: var(--stage-measure);
  margin-inline: auto;
}

.column--wide {
  max-width: var(--stage-wide);
}
</style>
